var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zeroInterest-card ap_zeroInterest mb-3"},[_c('h3',{staticClass:"zeroInterest-title"},[_c('i',{staticClass:"font-icons icons-credit-card"}),_vm._v("\n            Hasta "),_c('span',{staticClass:"zeroInterest-installmentsNumber"},[_vm._v("36")]),_vm._v(" "),_c('strong',[_vm._v("cuotas")])])])
}]

export { render, staticRenderFns }